/*
 * File: createRequestedUnavailebleProducts.ts
 * Project: meki
 * File Created: Thursday, 2nd February 2023 5:57:26 pm
 * Author: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Last Modified: Wednesday, 15th February 2023 12:19:28 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2023 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */
import { gql } from '@apollo/client';
import { RequestedUnavailableProducts } from '@interfaces';
import { ResolverParams } from '@queries/queries.interfaces';

export const CreateRequestedUnavailableProductsMutation = () => gql`
  mutation CreateRequestedUnavailableProducts(
    $params: CreateRequestedProductsParams!
  ) {
    createRequestedUnavailableProducts(params: $params) {
      id
      notificationEmail
      quantity
      productId
      notified
      userId
      dateNotified
    }
  }
`;

export type CreateRequestedProductsParams = ResolverParams<{
  productId: number;
  notificationEmail: string;
  quantity: number;
}>;
export type CreateRequestedProductsResponse = {
  createRequestedUnavailableProducts: RequestedUnavailableProducts;
};
